import React from 'react'
import './footer.css'
import {BsFacebook, BsInstagram} from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      {/* eslint-disable-next-line */}
      <a href="#" className='footer__logo'>Tariq Kharsa</a>
      <ul className='permalinks'>
        {/* eslint-disable-next-line */}
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className='footer__socials'>
        <a href="https://www.facebook.com/tariq.kharsa/" target="_blank" rel="noreferrer"><BsFacebook /></a>
        <a href="https://www.instagram.com/tariq_kharsa/" target="_blank" rel="noreferrer"><BsInstagram /></a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Tariq Kharsa. All rights reserved </small>
      </div>
    </footer>
  )
}

export default Footer